import {
	tableBodyStyle,
	tableRowStyle,
} from '../../../pages/CampaignManager/components/CampaignTable/CampaignTable.styles'
import { Skeleton, TableBody, TableCell, TableRow } from '@mui/material'
import React from 'react'
import { tableCellStyles } from './LoadingTable.styles'

type LoadingTableProps = {
	rows: number
	columns: number
}
export default function LoadingTable({ rows, columns }: LoadingTableProps) {
	return (
		<TableBody sx={tableBodyStyle}>
			{Array.from({ length: rows }).map((_, iRow) => (
				<TableRow key={iRow} sx={tableRowStyle}>
					{Array.from({ length: columns }).map((_, iColumn) => (
						<TableCell key={iColumn} sx={tableCellStyles}>
							<Skeleton animation="wave" />
						</TableCell>
					))}
				</TableRow>
			))}
		</TableBody>
	)
}
